import gql from 'graphql-tag';

import { logger } from '#src/lib/logger';

import { selectParams } from '../../../store/location/selectors';
import { canOpenHostFeed } from '../../../pages/GameHostFeed/helpers/is-game-host';
import { accessFields } from '../../../pages/GameHostFeed/queries';
import {
  authenticateWithTokenIfPresent,
  requireAuthentication,
  showNotFoundInPlace,
} from '../guards.js';

export const path = '/games/:gameId/feed';
export const component = 'GameHostFeed';

export const query = gql`
  query GameHostFeedAccess($gameId: Int!) {
    me {
      ...HostFeedAccessFields
    }
    game(id: $gameId, type: falkor) {
      ... on FalkorGame {
        id
        hostIds
      }
    }
  }
  ${accessFields}
`;

// The game's social feed, for its hosts and WayBetter staff (admins) only -
// players and everyone else get the 404 page, and anonymous visitors are sent to log in first.
// Nothing from the feed is loaded here: the page itself only loads posts in
// the browser (ssr: false), so no post ever reaches the server HTML.
//
// A host can arrive signed in by an auto-login link, /games/:gameId/feed
// ?token=…: the token signs them in first, replacing whoever was signed in
// (on the server the page then reloads without it), and the host check
// below runs for that account. A dead token signs nobody in, so they're
// sent to log in as usual.
export const thunk =
  ({ ctx, graphqlClient } = {}) =>
  async (dispatch, getState) => {
    if (await authenticateWithTokenIfPresent(dispatch, getState, ctx)) return;
    if (requireAuthentication(dispatch, getState)) return;

    const gameId = Number(selectParams(getState()).gameId) || null;
    let canOpen = false;

    if (gameId) {
      try {
        const { data, errors } = await graphqlClient.query({
          query,
          fetchPolicy: 'network-only',
          // A field that fails (say one the staff check reads) mustn't lock
          // out a host: decide on whatever came back.
          errorPolicy: 'all',
          variables: { gameId },
        });
        if (errors?.length) {
          logger.error('[game-host-feed] host access check errors', errors);
        }
        canOpen = canOpenHostFeed(data?.me, data?.game?.hostIds);
      } catch (error) {
        logger.error('[game-host-feed] failed to check host access', error);
      }
    }

    if (!canOpen) await showNotFoundInPlace(dispatch, getState);
  };
